import { BACKEND_URL_PREFIX, itemsOnPage } from '../utils/const';
import {
  GET_COURSE_BOOKS_REQUEST_COMPLETED,
  GET_COURSE_BOOKS_REQUEST_FAILED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_STARTED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_COMPLETED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_FAILED,
  GET_BOOK_INFO_REQUEST_START,
  GET_BOOK_INFO_REQUEST_COMPLETED,
  GET_BOOK_INFO_REQUEST_FAILED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_STARTED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_COMPLETED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_FAILED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_STARTED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_COMPLETED,
  GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_FAILED,
  SET_EDUCATION_WORK_PROGRAMS_COUNT,
} from './types';
import { buildDefaultHeaders } from './helper';
import { createNotification } from '../components/notifications/notifications';



export const fetchEducationWorkProgramByCourse = (idCurriculumCourse) =>
  async (dispatch, getState) =>{
    dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_STARTED });
    const url = `${BACKEND_URL_PREFIX}/educationworkprogram/0/0?id_curriculum_course=${idCurriculumCourse}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_COMPLETED, data: result });
    } else {
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_FAILED });
    }
  };

export const fetchEducationWorkPrograms = (numberPage, idcurriculum=0, idDiscipline=0, syid=0, type='disciplines') =>
  async (dispatch, getState) => {

    const params = {
      offset: numberPage * itemsOnPage,
      limit: itemsOnPage,
    }

    syid && (params.syid = syid)
    idcurriculum && (params.idcurriculum = idcurriculum)
    idDiscipline && (params.cid = idDiscipline)
    type && (params.type = type)

    const urlParams = new URLSearchParams(params).toString();

    dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_STARTED });
    const url = `${BACKEND_URL_PREFIX}/educationworkprogram?${urlParams}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json()
      // страниц — с округлением вверх, иначе последняя неполная страница недоступна
      const total = result.total || 0;
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_COMPLETED, data: result.items });
      dispatch({
        type: SET_EDUCATION_WORK_PROGRAMS_COUNT,
        data: Math.ceil(total / itemsOnPage),
        total,
      });
    } else {
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_FAILED });
    }
  };

export const fetchCourseBooks = id => async (dispatch, getState) => {
  const url = `${BACKEND_URL_PREFIX}/coursebooks/${id}`;
  const response = await fetch(`${url}`, buildDefaultHeaders(getState));
  if (response.ok) {
    const result = await response.json();
    dispatch({ type: GET_COURSE_BOOKS_REQUEST_COMPLETED, data: result });
  } else {
    dispatch({ type: GET_COURSE_BOOKS_REQUEST_FAILED });
  }
};

/*export const deleteCourseBook = (id, courseId) => async (dispatch, getState) => {
  dispatch({ type: DELETE_COURSE_BOOK_REQUEST_START });
  const url = `${BACKEND_URL_PREFIX}/coursebooks/${id}`;
  const response = await fetch(`${url}`, {
    method: 'DELETE',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
    },
  });
  if (response.ok) {
    const data = await response.json();
    data && dispatch(fetchCourseBooks(courseId));
  }
};*/

export const addCourseBook = data  => async (dispatch, getState) => {
  const url = `${BACKEND_URL_PREFIX}/coursebooks/${data.courseId}`;
  const response = await fetch(`${url}`, {
    method: 'POST',
    body: JSON.stringify({
      "library_bookid": data.bookId,
      "num": 2,
      "part": data.part,
      "razdel": "Основная"
    }),
    ...buildDefaultHeaders(getState),
  });
  if (response.ok) {
    const result = await response.json();
    result && dispatch(fetchCourseBooks(data.courseId));
  }
};

export const getBooksInfo = booksArray => async (dispatch, getState) => {
  const url = `${BACKEND_URL_PREFIX}/library/bookinfo`;
  dispatch({ type: GET_BOOK_INFO_REQUEST_START });
  const response = await fetch(`${url}`, {
    method: 'POST',
    body: JSON.stringify(booksArray),
    ...buildDefaultHeaders(getState),
  });

  if(response.ok) {
    const result = await response.json();
    dispatch({ type: GET_BOOK_INFO_REQUEST_COMPLETED, data: result });
    debugger
  } else {
    dispatch({ type: GET_BOOK_INFO_REQUEST_FAILED });
  }
};


export const fetchCourse = ({ idcurriculum = 0, idmetacourse = 0, idcathedra = 0, xp_key = 0, syid = 0 } = {}) =>
  async (dispatch, getState) => {
    dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_STARTED });

    const params = new URLSearchParams();
    if (idcurriculum) params.append('idcurriculum', idcurriculum);
    if (idmetacourse) params.append('idmetacourse', idmetacourse);
    if (idcathedra) params.append('idcathedra', idcathedra);
    if (xp_key) params.append('xp_key', xp_key);
    if (syid) params.append('syid', syid);

    const url = `${BACKEND_URL_PREFIX}/course/filters?${params.toString()}`;
    const response = await fetch(url, buildDefaultHeaders(getState));

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_COMPLETED, data: result });
    } else {
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_RPD_FAILED });
    }
  };
  
export const fetchMetaCourse = (syid, curriculumId, cid) =>
  async (dispatch, getState) => {
    dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_STARTED });
    const url = `${BACKEND_URL_PREFIX}/metacourse/${syid}/${curriculumId}/${cid}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_COMPLETED, data: result });
    } else {
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_FAILED });
    }
  };


export const fetchMetaCourseForUmk = (idcathedra = 0, idcurriculum = 0) =>
  async (dispatch, getState) => {
    dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_STARTED });
    const params = new URLSearchParams({
      idcathedra: idcathedra || 0,
      idcurriculum: idcurriculum || 0
    });
    const url = `${BACKEND_URL_PREFIX}/metacourse?${params.toString()}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json();
      // Новый API возвращает массив напрямую, нужно обернуть в объект для совместимости с reducer
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_COMPLETED, data: { meta_course: result } });
    } else {
      dispatch({ type: GET_EDUCATION_WORK_PROGRAMS_REQUEST_DISCIPLINE_FAILED });
    }
  };


  export const getSignedCopyFile = (courseId) => async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/educationworkprogram/${courseId}/signed-copy`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const blob = await response.blob();

      const objectUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = `Подписанная копия рабочей программы.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(objectUrl);
    } else {
      createNotification('error', 'Отсутствует подписанная копия рабочей программы');
    }
  }